import { configureStore } from "@reduxjs/toolkit";
import tabbedPageReducer from "../features/tabbedPage/tabbedPageSlice";
import userReducer from "../features/user/userSlice";
import appReducer from "../features/app/appSlice";
import versamentoTempiGiornalieroSliceReducer from "../features/versamentoTempiGiornaliero/versamentoTempiGiornalieroSlice";

export const store = configureStore({
  reducer: {
    tabbedPages: tabbedPageReducer,
    user: userReducer,
    app: appReducer,
    versamentoTempiGiornaliero: versamentoTempiGiornalieroSliceReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
